import SearchIcon from "@mui/icons-material/Search";
import * as React from "react";
import {styled} from "@mui/system";
import {InputBase, Typography} from "@mui/material";
import Box from "@mui/material/Box";

const BUTTON_WIDTH_WITH_TEXT = 124;
const BUTTON_WIDTH_ICON_ONLY = 56;

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: (theme) => theme.palette.text.light,
    width: "100%",
    minWidth: 0,
    height: "100%",
    boxSizing: "border-box",
    backgroundColor: "white",
    borderRadius: "6px",
    border: `${theme.palette.primary.main} 2px solid`,
    "& .MuiInputBase-input": {
        padding: "0 0 0 15px",
        fontSize: "16px",
        minWidth: 0,
    },
}));

const SearchIconWrapper = styled("div")(({theme}) => ({
    height: "100%",
    position: "absolute",
    right: 0,
    top: 0,
    width: BUTTON_WIDTH_WITH_TEXT,
    zIndex: 1,
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
        width: 25,
    },
}));

const SearchFixed = styled("div")(({theme}) => ({
    position: "relative",
    borderRadius: "6px",
    backgroundColor: theme.palette.primary.main,
    width: 352,
    height: 40,
}));

const SearchFixedInput = styled(InputBase)(({theme, $hasButtonText}) => ({
    color: (theme) => theme.palette.text.light,
    width: $hasButtonText ? "228px" : "296px",
    height: "100%",
    backgroundColor: "white",
    borderRadius: "6px",
    border: `${theme.palette.primary.main} 2px solid`,
    "& .MuiInputBase-input": {
        padding: "0 0 0 15px",
        fontSize: "16px",
    },
}));

export const SearchComponent = ({
                                    placeholder,
                                    buttonText,
                                    onClick,
                                    inputValue,
                                    handleInputChange,
                                    fullWidth = false,
                                }) => {
    const buttonWidth = buttonText ? BUTTON_WIDTH_WITH_TEXT : BUTTON_WIDTH_ICON_ONLY;

    const buttonLabel = buttonText ? (
        <Typography
            sx={{
                fontSize: "14px",
                color: "white",
                fontWeight: 700,
            }}
        >
            {buttonText}
        </Typography>
    ) : (
        <SearchIcon/>
    );

    if (fullWidth) {
        return (
            <Box
                onClick={() => onClick()}
                sx={{
                    display: "grid",
                    gridTemplateColumns: `minmax(0, 1fr) minmax(72px, ${buttonWidth}px)`,
                    "@media (max-width: 360px)": {
                        gridTemplateColumns: "minmax(0, 1fr) 100px",
                    },
                    width: "100%",
                    minWidth: 0,
                    maxWidth: "100%",
                    height: 40,
                    borderRadius: "6px",
                    overflow: "hidden",
                    cursor: "pointer",
                    backgroundColor: (theme) => theme.palette.primary.main,
                }}
            >
                <StyledInputBase
                    value={inputValue}
                    onChange={(event) => {
                        event.stopPropagation();
                        handleInputChange(event);
                    }}
                    placeholder={placeholder}
                    inputProps={{"aria-label": "search"}}
                />
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 0,
                        overflow: "hidden",
                        pointerEvents: "none",
                        "& .MuiTypography-root": {
                            fontSize: {xs: "12px", sm: "14px"},
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        },
                    }}
                >
                    {buttonLabel}
                </Box>
            </Box>
        );
    }

    return (
        <SearchFixed onClick={() => onClick()} sx={{cursor: "pointer"}}>
            <SearchIconWrapper sx={{width: `${buttonWidth}px`}}>
                {buttonLabel}
            </SearchIconWrapper>
            <SearchFixedInput
                $hasButtonText={Boolean(buttonText)}
                value={inputValue}
                onChange={(event) => {
                    event.stopPropagation();
                    handleInputChange(event);
                }}
                placeholder={placeholder}
                inputProps={{"aria-label": "search"}}
            />
        </SearchFixed>
    );
};
